import { Chip, styled, useTheme } from "@mui/material";

import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { isPropValid } from "Infrastructure/Utils/StyleUtils";
import { RegistrationRequestType } from "RegistrationRequests/Api/registrationRequestApi";

interface RegistrationRequestTypeChipProps {
  type: RegistrationRequestType;
}

const StyledChip = styled(Chip, { shouldForwardProp: isPropValid })<{
  $backgroundColor: string;
  $textColor: string;
}>`
  background-color: ${(props) => props.$backgroundColor};
  color: ${(props) => props.$textColor};
  font-size: 12px;
  font-weight: 400;

  .MuiChip-label {
    padding: ${(props) => props.theme.spacing(0, Spacing.M)};
  }
`;

const TYPE_LABELS: Record<
  RegistrationRequestType,
  (t: ReturnType<typeof useResource>["t"]) => string
> = {
  [RegistrationRequestType.Partner]: (t) =>
    t(Resources.RegistrationRequests.TypePartner),
  [RegistrationRequestType.Actor]: (t) =>
    t(Resources.RegistrationRequests.TypeActor),
};

export const RegistrationRequestTypeChip = ({
  type,
}: RegistrationRequestTypeChipProps): React.ReactNode => {
  const { t } = useResource();
  const theme = useTheme();

  const colorMap: Record<RegistrationRequestType, string> = {
    [RegistrationRequestType.Partner]: theme.palette.primary.dark,
    [RegistrationRequestType.Actor]: theme.palette.grey[700],
  };

  return (
    <StyledChip
      label={TYPE_LABELS[type](t)}
      $backgroundColor={colorMap[type]}
      $textColor={theme.palette.text.primary}
    />
  );
};
